<style src="./FormDataInput.scss" lang="scss" scoped></style>
<template>
  <form @submit.prevent="submitForm" class="row">
    <textbox
      class="col-12"
      :autofocus="true"
      label="Identificador"
      placeholder="PP 205"
      v-model="form.identification" />

    <suggest-client
      class="col-12"
      placeholder="Marinha do brasil"
      @selected="selectedClient"
      v-model="client"/>

    <textbox
      class="col-12"
      label="Código alternativo"
      placeholder="19856"
      v-model="form.alternativeCode" />

    <div class="col-12">
      <div class="row no-side-margin between-all">
        <datebox
          class="col-6"
          label="Data do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.date" />

        <timebox
          class="col-6"
          label="Hora do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.time" />
      </div>
    </div>

    <div class="col-12">
      <div class="row no-side-margin between-all">
        <datebox
          class="col-6"
          label="Data de entrega"
          placeholder="03/01/2078"
          v-model="eventPeriod.deadlineDate" />

        <timebox
          class="col-6"
          label="Hora do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.deadlineTime" />
      </div>
    </div>

    <div class="col-12">
      <label class="checkbox-label">
        <span class="label">Participa</span>

        <input
          class="checkbox-input"
          type="checkbox"
          v-model="form.participate">
      </label>
    </div>

    <div class="commands col-12">
      <button-submit
        class="col-5"
        label="Salvar Cliente"
        :state="commands.submitState"
        :icon-save="commands.saveIcon"/>

      <button
        class="btn-ghost col-5 cancel-button"
        type="button"
        @click="closePanel">
        <icon-close />
        Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import { Textbox, ButtonSubmit, Dropdown, Datebox, Timebox, SuggestClient } from '@/components/primitives'
import { IconSave, IconClose } from '@/components/primitives/icons'
import NewEvent from '@/brain/event/NewEvent'

export default {
  name: 'FormDataInput',
  components: {
    Textbox,
    Dropdown,
    Datebox,
    Timebox,
    ButtonSubmit,
    IconSave,
    IconClose,
    SuggestClient
  },
  data () {
    return {
      eventPeriod: {
        date: '',
        time: '',
        deadlineDate: '',
        deadlineTime: '090000'
      },
      form: {
        client: '',
        alternativeCode: '',
        identification: '',
        participate: true,
        status: 0
      },
      client: null,
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  computed: {
    eventPeriodComputed () {
      const eventOccur = `${this.eventPeriod.date} ${this.eventPeriod.time || '12:00:00'}`
      const eventDeadline = `${this.eventPeriod.deadlineDate} ${this.eventPeriod.deadlineTime || '12:00:00'}`
      return { eventOccur, eventDeadline }
    }
  },
  methods: {
    submitForm () {
      this.commands.submitState = 'WAIT'
      const formInformation = JSON.parse(JSON.stringify(this.form))
      formInformation.date = {
        deadline: this.eventPeriodComputed.eventDeadline,
        event: this.eventPeriodComputed.eventOccur
      }
      NewEvent(formInformation)
        .then((response) => {
          this.$toasted.success('Evento criado com sucesso')
          this.clearForm()
          this.commands.submitState = 'REPOSE'
          this.$emit('done')
        })
        .catch(() => {
          this.$toasted.error('Não foi possível criar o evento devido algum campo estar incorreto')
          this.commands.submitState = 'REPOSE'
        })
    },
    clearForm () {
      const form = {
        client: '',
        alternativeCode: '',
        date: {
          created: '',
          deadline: '',
          event: ''
        },
        identification: '',
        participate: true,
        status: 0
      }
      this.form = form
    },
    closePanel () {
      this.$parent.$emit('close', false)
    },
    orderClientList: (pList) => {
      const r = Object.values(pList).sort((a, b) => {
        return b.shortName.trim() - a.shortName.trim()
      })
      return r
    },
    selectedClient (pItem) {
      this.form.client = pItem.source._id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/new-event/form-data-input/FormDataInput.vue